var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrcticasCrditoResponsable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.748,
    height: 129.001,
    viewBox: "0 0 129.748 129.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23114",
    "data-name": "Grupo 23114",
    transform: "translate(0.519 0.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23091",
    "data-name": "Grupo 23091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15672",
    "data-name": "Grupo 15672",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15056",
    "data-name": "Grupo 15056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_17",
    "data-name": "Uni\\xF3n 17",
    d: "M5.86,82.5H126.051s-27.324,32.128-66.617,33q-.748.017-1.484.017C19.783,115.516,5.86,82.5,5.86,82.5Zm.2,0S-3.367,70.318,1.294,46.788c2.931-14.8,15.245-22.133,31.751-21.433,5.674.241,14.907-6.93,28.171-15.74,28.374-18.843,69.418-10.84,59.595,31.543C116.058,61.67,135.764,62,125.969,82.5Z",
    fill: "#d5dced",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23092",
    "data-name": "Grupo 23092",
    transform: "translate(19.985 39.763)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1788",
    "data-name": "Elipse 1788",
    cx: 14.585,
    cy: 14.585,
    rx: 14.585,
    ry: 14.585,
    transform: "translate(32.861 6.93)",
    fill: "#ffc4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108579",
    "data-name": "Trazado 108579",
    d: "M-2816.371-13236.55v-6.544h-5.889l9.867-9.718,9.667,9.718h-5.008v10.069Z",
    transform: "translate(2841.875 13294.689)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108580",
    "data-name": "Trazado 108580",
    d: "M-2799.206-13218.41v-19.622h-5.283l9.715-9.535,9.246,9.535h-4.5v16.507Z",
    transform: "translate(2849.471 13296.932)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108581",
    "data-name": "Trazado 108581",
    d: "M-2782.886-13228.2v-16.592h-6.686l11.03-10.51,9.173,10.51h-4.646v16.592Z",
    transform: "translate(2855.85 13293.623)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108582",
    "data-name": "Trazado 108582",
    d: "M-2820.437-13243.053h-8.891v-10.257h-5.373l10.032-10.059,9.726,10.059h-5.494Z",
    transform: "translate(2836.556 13290.175)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "purchasing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108572",
    "data-name": "Trazado 108572",
    d: "M77.111,60.45a4.473,4.473,0,0,0-3.918-.71L62.621,62.86V49.7h4.436a1.459,1.459,0,0,0,1.36-.917,1.479,1.479,0,0,0-.31-1.612l-10.35-10.35a1.49,1.49,0,0,0-2.1,0l-10.35,10.35A1.479,1.479,0,0,0,45,48.784a1.459,1.459,0,0,0,1.36.917h4.436V65.965H40.827L32.843,61.53H44.878a4.449,4.449,0,0,0,4.436-4.436v-.739A4.458,4.458,0,0,0,46.135,52.1l-8.65-2.543V42.308h4.436a1.459,1.459,0,0,0,1.36-.917,1.479,1.479,0,0,0-.311-1.612L32.621,29.43a1.49,1.49,0,0,0-2.1,0L20.172,39.78a1.479,1.479,0,0,0-.31,1.612,1.459,1.459,0,0,0,1.36.917h4.436v3.77l-2.543-.754a1.276,1.276,0,0,0-.414-.059H13.829V42.308A1.479,1.479,0,0,0,12.35,40.83H3.479A1.479,1.479,0,0,0,2,42.308V74.837a1.479,1.479,0,0,0,1.479,1.479H12.35a1.479,1.479,0,0,0,1.479-1.479v-2.38L29.62,77.72a1.752,1.752,0,0,0,.473.074H52.271a1.358,1.358,0,0,0,.488-.089l23.169-8.176a4.436,4.436,0,0,0,2.957-4.184V64A4.412,4.412,0,0,0,77.111,60.45ZM10.871,73.358H4.957V43.787h5.914ZM49.92,46.744l6.787-6.787,6.787,6.787H61.143a1.479,1.479,0,0,0-1.479,1.479v15.51l-5.914,1.73V48.223a1.479,1.479,0,0,0-1.479-1.479ZM24.785,39.351l6.787-6.787,6.787,6.787H36.007a1.479,1.479,0,0,0-1.479,1.479v7.851l-5.914-1.745V40.83a1.479,1.479,0,0,0-1.479-1.479ZM75.928,65.344a1.479,1.479,0,0,1-.991,1.4L52.02,74.837H30.329l-16.5-5.5V48.223h8.664l22.8,6.713a1.49,1.49,0,0,1,1.065,1.419v.739a1.479,1.479,0,0,1-1.479,1.479H27.136a1.479,1.479,0,0,0-.724,2.765L39.718,68.73a1.4,1.4,0,0,0,.724.192H52.271a1.276,1.276,0,0,0,.414-.059l21.35-6.284A1.479,1.479,0,0,1,75.928,64Z",
    transform: "translate(-2 10.92)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108573",
    "data-name": "Trazado 108573",
    d: "M41.178,2A22.178,22.178,0,1,0,63.357,24.178,22.178,22.178,0,0,0,41.178,2ZM60.326,22.7H57.369a16.4,16.4,0,0,0-1.434-5.323l2.558-1.493A19.254,19.254,0,0,1,60.326,22.7ZM52.031,8.328a19.582,19.582,0,0,1,5,5L54.456,14.8a16.865,16.865,0,0,0-3.9-3.9Zm-9.374-3.3a19.254,19.254,0,0,1,6.816,1.833L47.98,9.422a16.4,16.4,0,0,0-5.323-1.434Zm-2.957,0V7.988a16.4,16.4,0,0,0-5.323,1.434L32.884,6.864A19.254,19.254,0,0,1,39.7,5.031Zm-9.374,3.3L31.8,10.9a16.864,16.864,0,0,0-3.9,3.9l-2.573-1.479a19.582,19.582,0,0,1,5-5Zm-6.461,7.555,2.558,1.493A16.4,16.4,0,0,0,24.988,22.7H22.031a19.254,19.254,0,0,1,1.833-6.816Zm-1.833,9.773h2.957a16.4,16.4,0,0,0,1.434,5.323l-2.558,1.493a19.254,19.254,0,0,1-1.833-6.816Zm8.295,14.372a19.582,19.582,0,0,1-5-5L27.9,33.553a16.864,16.864,0,0,0,3.9,3.9Zm9.374,3.3a19.254,19.254,0,0,1-6.816-1.833l1.493-2.558A16.4,16.4,0,0,0,39.7,40.369ZM27.871,24.178A13.307,13.307,0,1,1,41.178,37.486,13.307,13.307,0,0,1,27.871,24.178ZM42.657,43.326V40.369a16.4,16.4,0,0,0,5.323-1.434l1.493,2.558A19.254,19.254,0,0,1,42.657,43.326Zm9.374-3.3-1.479-2.573a16.865,16.865,0,0,0,3.9-3.9l2.573,1.479A19.582,19.582,0,0,1,52.031,40.029Zm6.461-7.555L55.935,30.98a16.4,16.4,0,0,0,1.434-5.323h2.957a19.254,19.254,0,0,1-1.833,6.816Z",
    transform: "translate(6.136 -2)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108575",
    "data-name": "Trazado 108575",
    d: "M69.224,37.783l-10.35-10.35a1.479,1.479,0,0,0-2.091,0l-10.35,10.35a1.479,1.479,0,0,0,1.045,2.524h4.436V55.093a1.479,1.479,0,0,0,1.479,1.479h8.871a1.479,1.479,0,0,0,1.479-1.479V40.307h4.436a1.479,1.479,0,0,0,1.045-2.524Zm-6.96-.433a1.479,1.479,0,0,0-1.479,1.479V53.614H54.871V38.828a1.479,1.479,0,0,0-1.479-1.479H51.048l6.781-6.781,6.781,6.781Z",
    transform: "translate(19.057 9.964)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108576",
    "data-name": "Trazado 108576",
    d: "M3.478,32.307H7.914v8.871a1.479,1.479,0,0,0,1.479,1.479h8.871a1.479,1.479,0,0,0,1.479-1.479V32.307h4.436a1.479,1.479,0,0,0,1.045-2.524l-10.35-10.35a1.479,1.479,0,0,0-2.091,0L2.433,29.783a1.479,1.479,0,0,0,1.045,2.524Zm10.35-9.738,6.781,6.781H18.264a1.479,1.479,0,0,0-1.479,1.479V39.7H10.871V30.828A1.479,1.479,0,0,0,9.393,29.35H7.048Z",
    transform: "translate(-2 6.136)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108578",
    "data-name": "Trazado 108578",
    d: "M192.707,153.568a3.09,3.09,0,0,1-2.488-.793,1.335,1.335,0,1,0-2.08,1.675,4.9,4.9,0,0,0,2.693,1.611,1.335,1.335,0,0,0,2.637.1,3.766,3.766,0,0,0,3.257-3.179,4.269,4.269,0,0,0-3.013-4.461c-1.328-.47-2.1-.778-2.36-.9a.775.775,0,0,1-.549-.788.971.971,0,0,1,.6-.838c1.2-.362,1.989-.009,2.2.3a1.335,1.335,0,0,0,2.186-1.534,3.853,3.853,0,0,0-2.3-1.462,1.335,1.335,0,0,0-2.667.088q-.094.025-.189.054a3.649,3.649,0,0,0-2.493,3.2,3.409,3.409,0,0,0,2.073,3.4c.427.2,1.4.576,2.608,1a1.65,1.65,0,0,1,1.254,1.607C193.987,153.352,193.18,153.527,192.707,153.568Z",
    transform: "translate(-144.986 -127.467)",
    fill: "#ee2b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrcticasCrditoResponsable);
export default __webpack_public_path__ + "static/media/Prácticas_crédito_Responsable.cd5921ce1eb581583e911296b8fb5b0e.svg";
export { ForwardRef as ReactComponent };